<template>
  <modal
    :id="modalId"
    :title="title"
    :visible="true"
    :button1-caption="capitalize($t('actions.update'))"
    :button3-caption="capitalize($t('actions.cancel'))"
    :button2-caption="capitalize($t('messages.saveAsNewView'))"
    :button2-visible="true"
    :button3-visible="true"
    :use-full-width="false"
    @cancelled="onClose"
    :button1-callback="save"
    :button2-callback="saveAsNew"
    :button3-callback="onClose">
    <template #modal-after-form>
      <div>
        <p>
          {{ $t('messages.aboutToUpdate') }}: <b>{{ viewName }}.</b>
        </p>
      </div>
    </template>
  </modal>
</template>

<script lang="ts" setup>
  import { capitalize, computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import Modal from '@/common/components/controls/Modal.vue';
  import { capitalizeTranslation } from '@/globals';

  interface IProps {
    viewName: string;
  }

  const { viewName } = defineProps<IProps>();
  const { t } = useI18n();

  const emits = defineEmits(['save', 'saveAsNew', 'close']);

  const modalId = 'update-user-view-modal';

  const title = computed(() => capitalizeTranslation('messages.updateView'));

  function saveAsNew() {
    emits('saveAsNew');
  }

  function onClose() {
    emits('close');
  }

  function save() {
    emits('save');
  }
</script>
